import { Routes } from '@/router/routes'
import { RouterContexts } from '@/router/RouterContexts'

import { Middleware } from '@/types/enums/middleware/middleware'

export const errorRoutes = [
  {
    path: '/403',
    name: Routes.Forbidden,
    component: () => import('@/pages/contexts/portal/Forbidden.vue'),
    meta: {
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      routerContexts: [
        RouterContexts.PORTAL_CONTEXT,
        RouterContexts.DAILY_AGENDA_CONTEXT,
      ],
    },
  },
  {
    path: '/:catchAll(.*)',
    name: Routes.NotFound,
    component: () => import('@/pages/contexts/portal/NotFound.vue'),
    meta: {
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      routerContexts: [
        RouterContexts.PORTAL_CONTEXT,
        RouterContexts.DAILY_AGENDA_CONTEXT,
      ],
    },
  },
]
